<div class="analytics-header vss-header-bar p-3 mb-2">
  <div style="display: flex; align-items: center; justify-content: space-between">
    <div class="filter-group time-group vss-time-group-flex">
      <div class="filter-label">Time Range</div>
      <kendo-dropdownlist
        [data]="timeRanges()"
        [value]="selectedTimeRange()"
        (valueChange)="onTimeRangeChange.emit($event)"
        [textField]="'text'"
        [valueField]="'value'"
        class="vss-dropdown"
      ></kendo-dropdownlist>
      <div
        class="date-range vss-date-range"
        *ngIf="selectedTimeRange() && selectedTimeRange().value === 'custom'"
      >
        <kendo-datepicker
          [value]="startDate()"
          (valueChange)="onStartDateChange.emit($event)"
          placeholder="Start date"
          class="vss-datepicker"
        ></kendo-datepicker>
        <span>to</span>
        <kendo-datepicker
          [value]="endDate()"
          (valueChange)="onEndDateChange.emit($event)"
          placeholder="End date"
          class="vss-datepicker"
        ></kendo-datepicker>
      </div>
    </div>
    <div class="d-flex gap-2">
      <button
        kendoButton
        themeColor="primary"
        size="large"
        (click)="onApplyFilters.emit()"
        [svgIcon]="filterIcon"
      >
        Apply Filters
      </button>
    </div>
  </div>
</div>
